export const zenClearUltraPrescriptionErrorFields = [
  {
    field: 'ZenClearUltra.angleClassification',
    label: 'prescription.step2_angle_classification'
  },
  {
    field: 'ZenClearUltra.patientDiagnosis.diagnosis',
    label: 'prescription.step3_diagnosis'
  },
  {
    field: 'ZenClearUltra.patientDiagnosis.otherText',
    label: 'prescription.step3_diagnosis'
  },
  {
    field: 'ZenClearUltra.chiefComplaints.complaints',
    label: 'prescription.step4_chief_complaints'
  },
  {
    field: 'ZenClearUltra.chiefComplaints.otherText',
    label: 'prescription.step4_chief_complaints'
  },
  {
    field: 'ZenClearUltra.mainObjectives.objectives',
    label: 'prescription.step5_main_objectives'
  },
  {
    field: 'ZenClearUltra.mainObjectives.otherText',
    label: 'prescription.step5_main_objectives'
  },
  {
    field: 'ZenClearUltra.archesToTreat.arches',
    label: 'prescription.step6_arch_to_treat'
  },
  {
    field: 'ZenClearUltra.archesToTreat.passiveAligners',
    label: 'prescription.step6_arch_to_treat'
  },
  {
    field: 'ZenClearUltra.toothInformation.information',
    label: 'prescription.step7_tooth_info'
  },
  {
    field: 'ZenClearUltra.toothInformation.toothChart',
    label: 'prescription.step7_tooth_info'
  },
  {
    field: 'ZenClearUltra.toothInformation.primaryToothChart',
    label: 'prescription.step7_tooth_info'
  },
  {
    field: 'ZenClearUltra.toothMovementRestriction.restriction',
    label: 'prescription.step8_tooth_movement'
  },
  {
    field: 'ZenClearUltra.toothMovementRestriction.toothChart',
    label: 'prescription.step8_tooth_movement'
  },
  {
    field: 'ZenClearUltra.toothMovementRestriction.primaryToothChart',
    label: 'prescription.step8_tooth_movement'
  },
  {
    field: 'ZenClearUltra.toothAttachment.attachment',
    label: 'prescription.step9_tooth_attachment'
  },
  {
    field: 'ZenClearUltra.toothAttachment.toothChart',
    label: 'prescription.step9_tooth_attachment'
  },
  {
    field: 'ZenClearUltra.toothAttachment.primaryToothChart',
    label: 'prescription.step9_tooth_attachment'
  },
  {
    field: 'ZenClearUltra.sagittalRelationship.relationship',
    label: 'prescription.step10_sagittal_relationship'
  },
  {
    field: 'ZenClearUltra.sagittalRelationship.bothRandL.rightAndLeftAction',
    label: 'prescription.step10_sagittal_relationship'
  },
  {
    field: 'ZenClearUltra.sagittalRelationship.bothRandL.afterAlignment.text',
    label: 'prescription.step10_sagittal_relationship'
  },
  {
    field:
      'ZenClearUltra.sagittalRelationship.bothRandL.improveCanine.improveSubOptions',
    label: 'prescription.step10_sagittal_relationship'
  },
  {
    field:
      'ZenClearUltra.sagittalRelationship.bothRandL.improveMolar.improveSubOptions',
    label: 'prescription.step10_sagittal_relationship'
  },
  {
    field:
      'ZenClearUltra.sagittalRelationship.eitherRorL.right.afterAlignment.text',
    label: 'prescription.step10_sagittal_relationship'
  },
  {
    field:
      'ZenClearUltra.sagittalRelationship.eitherRorL.left.afterAlignment.text',
    label: 'prescription.step10_sagittal_relationship'
  },
  {
    field:
      'ZenClearUltra.sagittalRelationship.eitherRorL.right.improveCanine.improveSubOptions',
    label: 'prescription.step10_sagittal_relationship'
  },
  {
    field:
      'ZenClearUltra.sagittalRelationship.eitherRorL.right.improveMolar.improveSubOptions',
    label: 'prescription.step10_sagittal_relationship'
  },
  {
    field:
      'ZenClearUltra.sagittalRelationship.eitherRorL.left.improveCanine.improveSubOptions',
    label: 'prescription.step10_sagittal_relationship'
  },
  {
    field:
      'ZenClearUltra.sagittalRelationship.eitherRorL.left.improveMolar.improveSubOptions',
    label: 'prescription.step10_sagittal_relationship'
  },
  { field: 'ZenClearUltra.overjet', label: 'prescription.step11_overjet' },
  {
    field: 'ZenClearUltra.overbite.overBite',
    label: 'prescription.step12_overbite'
  },
  {
    field: 'ZenClearUltra.overbite.correctOpenBite.Upper.upper',
    label: 'prescription.step12_overbite'
  },
  {
    field: 'ZenClearUltra.overbite.correctOpenBite.Lower.lower',
    label: 'prescription.step12_overbite'
  },
  {
    field: 'ZenClearUltra.overbite.ImproveDeepBite.Upper.upper',
    label: 'prescription.step12_overbite'
  },
  {
    field: 'ZenClearUltra.overbite.ImproveDeepBite.Lower.lower',
    label: 'prescription.step12_overbite'
  },
  {
    field: 'ZenClearUltra.overbite.ImproveDeepBite.Upper.anteriorBiteRamps',
    label: 'prescription.step12_overbite'
  },
  {
    field: 'ZenClearUltra.midline.Midline',
    label: 'prescription.step13_midline'
  },
  {
    field: 'ZenClearUltra.midline.ImproveMidline.Upper.upper',
    label: 'prescription.step13_midline'
  },
  {
    field: 'ZenClearUltra.midline.ImproveMidline.Lower.lower',
    label: 'prescription.step13_midline'
  },
  {
    field: 'ZenClearUltra.midline.ImproveMidline.Lower.adjustPatient',
    label: 'prescription.step13_midline'
  },
  {
    field: 'ZenClearUltra.midline.ImproveMidline.Upper.adjustPatient',
    label: 'prescription.step13_midline'
  },
  {
    field: 'ZenClearUltra.spacing.Spacing',
    label: 'prescription.step14_spacing'
  },
  {
    field: 'ZenClearUltra.spacing.upper',
    label: 'prescription.step14_spacing'
  },
  {
    field: 'ZenClearUltra.spacing.lower',
    label: 'prescription.step14_spacing'
  },
  {
    field: 'ZenClearUltra.spacing.toothSpacing.space',
    label: 'prescription.step14_spacing'
  },
  {
    field: 'ZenClearUltra.spacing.toothSpacing.toothChart',
    label: 'prescription.step14_spacing'
  },
  {
    field: 'ZenClearUltra.crowding.Crowding',
    label: 'prescription.step15_crowding'
  },
  {
    field: 'ZenClearUltra.crowding.resolveCrowding.lower.archExpansion',
    label: 'prescription.step15_crowding'
  },
  {
    field: 'ZenClearUltra.crowding.resolveCrowding.lower.molarDistalization',
    label: 'prescription.step15_crowding'
  },
  {
    field: 'ZenClearUltra.crowding.resolveCrowding.lower.proclination',
    label: 'prescription.step15_crowding'
  },
  {
    field: 'ZenClearUltra.crowding.resolveCrowding.lower.ipr.Ipr',
    label: 'prescription.step15_crowding'
  },
  {
    field: 'ZenClearUltra.crowding.resolveCrowding.lower.ipr.anteriorTeeth',
    label: 'prescription.step15_crowding'
  },
  {
    field:
      'ZenClearUltra.crowding.resolveCrowding.lower.ipr.rightPosteriorTeeth',
    label: 'prescription.step15_crowding'
  },
  {
    field:
      'ZenClearUltra.crowding.resolveCrowding.lower.ipr.leftPosteriorTeeth',
    label: 'prescription.step15_crowding'
  },
  {
    field: 'ZenClearUltra.crowding.resolveCrowding.upper.archExpansion',
    label: 'prescription.step15_crowding'
  },
  {
    field: 'ZenClearUltra.crowding.resolveCrowding.upper.molarDistalization',
    label: 'prescription.step15_crowding'
  },
  {
    field: 'ZenClearUltra.crowding.resolveCrowding.upper.proclination',
    label: 'prescription.step15_crowding'
  },
  {
    field: 'ZenClearUltra.crowding.resolveCrowding.upper.ipr.Ipr',
    label: 'prescription.step15_crowding'
  },
  {
    field: 'ZenClearUltra.crowding.resolveCrowding.upper.ipr.anteriorTeeth',
    label: 'prescription.step15_crowding'
  },
  {
    field:
      'ZenClearUltra.crowding.resolveCrowding.upper.ipr.rightPosteriorTeeth',
    label: 'prescription.step15_crowding'
  },
  {
    field:
      'ZenClearUltra.crowding.resolveCrowding.upper.ipr.leftPosteriorTeeth',
    label: 'prescription.step15_crowding'
  },
  {
    field: 'ZenClearUltra.extraction.Extraction',
    label: 'prescription.step16_extraction'
  },
  {
    field: 'ZenClearUltra.extraction.toothChart',
    label: 'prescription.step16_extraction'
  },
  {
    field: 'ZenClearUltra.extraction.primaryToothChart',
    label: 'prescription.step16_extraction'
  },
  {
    field: 'ZenClearUltra.auxiliaries',
    label: 'prescription.step17_auxiliaries',
    animateLabel: 'auxiliaries'
  },
  {
    field: 'ZenClearUltra.additionalAppliances',
    label: 'prescription.step18_additional_appliances',
    animateLabel: 'additionalAppliances'
  },
  {
    field: 'ZenClearUltra.specialNotes',
    label: 'prescription.step19_special_notes'
  }
];
